export default "__VITE_ASSET__CllTatCC__"